<template>
  <div>
    <ToastPrime />
    <div class="justify-content-center align-items-center m-6">
      <DataTablePrime
        title="Prime"
        :value="economicData.fuelEconomicDatasInitial"
        editMode="cell"
        class="editable-cells-table"
        responsiveLayout="scroll"
        @cell-edit-complete="onCellEditComplete"
      >
        <template #header>
          <div class="flex justify-content-left align-items-left">
            <label class="m-0">{{ $t("baseConfiguration") }}: {{ configurationBaseName }} (EEXI = {{ baseEEXI }} )</label>
          </div>
        </template>
        <ColumnPrime
          v-for="col of tableColumns"
          :field="col.field"
          :header="$t(col.header)"
          :key="col.field"
          style="width: 20%"
        >
          <template #editor="{ data, field }">
            <InputTextPrime v-model="data[field]" autofocus />
          </template>
        </ColumnPrime>
        <ColumnPrime field="consumptionInTonsName" :header="$t('annualConsumptionType')" style="width: 20%">
          <template #editor="{ data, field }">
            <DropdownPrime v-model="data[field]" :options="consumptionOptions" autofocus />
          </template>
        </ColumnPrime>
      </DataTablePrime>
    </div>
    <div class="text-left m-6">
      <div class="formgrid grid">
        <div class="field col-12 md:col-2 pt-4">
          <label>{{ $t("miscellaneousCosts") }}:</label>
        </div>
        <div class="field col-12 md:col-1">
          <InputTextPrime type="number" v-model="economicData.miscellaneousCostsInitial" autofocus />
        </div>
        <div class="field col-12 md:col-8"></div>
      </div>
    </div>
    <div class="justify-content-center align-items-center m-6">
      <DataTablePrime
        header="fdsa"
        v-if="!economicData.isBase"
        :value="economicData.fuelEconomicDatasModified"
        editMode="cell"
        @cell-edit-complete="onCellEditComplete"
        class="editable-cells-table"
        responsiveLayout="scroll"
      >
        <template #header>
          <div class="flex justify-content-left align-items-left">
            <label class="m-0"
              >{{ $t("configuration") }}: {{ configurationName }} (EEXI = {{ configurationEEXI }} )</label
            >
          </div>
        </template>
        <ColumnPrime
          v-for="col of tableColumns"
          :field="col.field"
          :header="$t(col.header)"
          :key="col.field"
          style="width: 20%"
        >
          <template #editor="{ data, field }">
            <InputTextPrime v-model="data[field]" autofocus />
          </template>
        </ColumnPrime>
        <ColumnPrime field="consumptionInTonsName" :header="$t('annualConsumptionType')" style="width: 20%">
          <template #editor="{ data, field }">
            <DropdownPrime v-model="data[field]" :options="consumptionOptions" autofocus />
          </template>
        </ColumnPrime>
      </DataTablePrime>
    </div>
    <div class="text-left m-6">
      <div class="formgrid grid">
        <div class="field col-12 md:col-5 pt-2">
          <div class="formgrid grid">
            <div class="field col-12 md:col-6 pt-4 pb-6" v-if="!economicData.isBase">
              <label>{{ $t("miscellaneousCosts") }}:</label>
            </div>
            <div class="field col-12 md:col-6" v-if="!economicData.isBase">
              <InputTextPrime type="number" v-model="economicData.miscellaneousCostsModified" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("technicalStopDuration") }} ({{ $t("timeDays") }})</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.technicalStopDuration" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("dailyCosts") }} (&euro;)</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.dailyCosts" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4">
              <h4>{{ $t("initialInvestment") }}:</h4>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.initialInvestment" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4" v-if="economicData.financing">
              <label>{{ $t("financing") }}:</label>
            </div>
            <div class="field col-12 md:col-6" v-if="economicData.financing">
              <InputTextPrime type="number" v-model="economicData.initialInvestment" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("amountToFinance") }}</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.amountToFinance" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("interestRate") }}</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.interestRate" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("amortizationPeriod") }}</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.amortizationPeriod" autofocus />
            </div>
            <div class="field col-12 md:col-6 pt-4 pl-8">
              <label>{{ $t("discountRate") }}</label>
            </div>
            <div class="field col-12 md:col-6">
              <InputTextPrime type="number" v-model="economicData.discountRate" autofocus />
            </div>
          </div>
        </div>
        <div class="field col-12 md:col-1 pt-2"></div>
        <div class="field col-12 md:col-6 pt-2">
          <div class="card">
            <DropdownPrime
              v-model="selectedChart"
              optionLabel="name"
              @change="chartSelection"
              :options="chartOptions"
              placeholder="Select data"
            />
            <ChartPrime type="bar" :data="chartData" />
          </div>
        </div>
        <div class="field col-12 md:col-9 pt-4"></div>
        <div class="field col-12 md:col-1 pt-4">
          <ButtonPrime :label="$t('calculate')" icon="pi" @click="calc()" class="p-button actionButton" />
        </div>
        <div class="field col-12 md:col-1 pt-4">
          <ButtonPrime :label="$t('close')" icon="pi pi-times" @click="close()" class="p-button actionButton" />
        </div>
        <div class="field col-12 md:col-1 pt-4">
          <ButtonPrime :label="$t('save')" icon="pi pi-save" @click="save()" class="p-button actionButton" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EconomicService from "@/services/EconomicService";
import store from "@/store/index";
import router from "@/router/index";
import { ToastSeverity } from "primevue/api";

export default {
  data() {
    return {
      economicData: store.getters.currentConfiguration.economicData,
      tableColumns: [
        {
          field: "name",
          header: "fuelName",
        },
        {
          field: "annualConsumption",
          header: "annualConsumption",
        },
        {
          field: "price",
          header: "price",
        },
        {
          field: "annualPriceIncrease",
          header: "annualPriceIncrease",
        },
      ],
      chartOptions: [
        { name: "Annual Rentability", code: "AR" },
        { name: "Interest per year", code: "IPR" },
        { name: "Van per year", code: "VPY" },
        { name: "Ecoefficiency", code: "ECO" },
      ],
      consumptionOptions: ["MWh", "t"],
      selectedChart: {},
      chartData: {
        labels: [],
        datasets: [
          {
            label: "Choose a data set",
            backgroundColor: "#42A5F5",
            data: [],
          },
        ],
      },
      configurationEEXI: 0,
      baseEEXI: 0,
      configurationName: "",
      configurationBaseName: "",
    };
  },
  created() {
    this.economicService = EconomicService.getInstance();
    const eexiData = this.economicService.getEEXIDataForEconomic(
      store.getters.currentConfiguration,
      store.getters.currentShip
    );
    this.configurationEEXI = eexiData.configurationEEXI;
    this.baseEEXI = eexiData.baseEEXI;
    this.configurationName = eexiData.configurationName
    this.configurationBaseName = eexiData.configurationBaseName
  },
  mounted() {
    //console.log(this.economicData);
  },
  methods: {
    save() {
      this.economicService.saveEconomicData(
        store.getters.currentShip.id,
        store.getters.currentConfiguration,
        this.economicData
      );
    },
    calc() {
      const calculatedData = EconomicService.getInstance().calcEconomicData(
        store.getters.currentConfiguration,
        store.getters.currentShip
      );

      this.economicData.annualRentability = calculatedData.annualRentability;
      this.economicData.interestPerYear = calculatedData.interestPerYear;
      this.economicData.vanPerYear = calculatedData.vanPerYear;
      this.economicData.ecoEfficiency = calculatedData.ecoEfficiency;

      //console.log("CalculatedData:", calculatedData);

      this.showToast(true, "Result " + this.economicData.ecoEfficiency.length);
    },
    showToast(successful, message) {
      if (successful) {
        this.$toast.add({
          severity: ToastSeverity.SUCCESS,
          closable: false,
          summary: message,
          life: 3000,
        });
      } else {
        this.$toast.add({
          severity: ToastSeverity.ERROR,
          closable: false,
          summary: message,
          life: 3000,
        });
      }
    },
    close() {
      router.push({
        name: "home",
      });
    },
    onCellEditComplete(event) {
      let { data, newValue, field } = event;
      //falta por ponerle una opcion para el campo de codigo para verificar que pone uno correcto.
      switch (field) {
        case "consumptionInTonsName":
          data[field] = newValue;
          break;
        default:
          if (newValue.trim().length > 0) data[field] = newValue;
          else event.preventDefault();
          break;
      }
    },
    chartSelection(event) {
      console.log(event.value);

      switch (event.value.code) {
        case "AR":
          this.chartData.datasets[0].data = this.economicData.annualRentability;
          this.chartData.datasets[0].label = "Annual Rentability";
          break;
        case "IPR":
          this.chartData.datasets[0].data = this.economicData.interestPerYear;
          this.chartData.datasets[0].label = "Interest per year";
          break;
        case "VPY":
          this.chartData.datasets[0].data = this.economicData.vanPerYear;
          this.chartData.datasets[0].label = "Van per year";
          break;
        case "ECO":
          this.chartData.datasets[0].data = this.economicData.ecoEfficiency;
          this.chartData.datasets[0].label = "Ecoefficiency";
          break;
      }
      this.chartData.labels = Array.from(Array(this.economicData.annualRentability.length).keys());
    },
  },
};
</script>
<style scoped>
#smallTableContainer {
  width: 80%;
  padding-left: 100px;
}

.field {
  margin-bottom: 15px !important;
}
</style>
